import { ADD_ONS } from '../Pricing';
import BaselineSettings from './settings/BaselineSettings';
import FileUploadSettings from './settings/FileUploadSettings';
import AutoEngageSettings from './settings/AutoEngageSettings';
import AutoReplySettings from './settings/AutoReplySettings';
import ContactModuleSettings from './settings/ContactModuleSettings';
import { Accordion } from './primitives';
import VisualizerSettings from './settings/VisualizerSettings';

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

function getRandomWelcomeMessage() {
    const welcomeMessages = [
        'Welcome to our chat! How can I help you today?',
        'Hello! How can I assist you today?',
        'Hi there! What can I do for you today?',
        'Welcome! How can I help you today?',
        'Hello! How can I help you today?',
        'Hi there! What can I do for you today?',
        'Welcome! How can I help you today?',
        'Hello! How can I help you today?',
    ];
    return welcomeMessages[Math.floor(Math.random() * welcomeMessages.length)];
}

function getRandomNewMessageTitle() {
    const chatTitles = [
        'Chat with us!',
        'New Message!',
        'Message Us!',
    ];
    return chatTitles[Math.floor(Math.random() * chatTitles.length)];
}

function getRandomAutoReply() {
    const autoReplies = [
        { option: 'Hello', reply: 'Hello! How can I assist you today?' },
        { option: 'Hi', reply: 'Hi! How can I help you today?' },
        { option: 'Hey', reply: 'Hey! How can I assist you today?' },
        { option: 'Greetings', reply: 'Greetings! How can I help you today?' },
        { option: 'Good Day', reply: 'Good Day! How can I assist you today?' },
    ];
    return autoReplies[Math.floor(Math.random() * autoReplies.length)];
}

export default function WorkspaceSettingsTab({ 
    newSubscriptionItem,
    config,
    workspaceId,
    workspaceType,
    post,
    url,
    workspace,
    setConfig,
    baselineProps,
    fileUploadProps,
    autoEngageProps,
    autoReplyProps,
    contactModuleProps,
    requestedVisualTrigger,
}) {

    const props = {
        config,
        workspaceId,
        days: DAYS,
        setConfig,
        post,
        url,
        workspace,
        workspaceType,
        getRandomAutoReply,
        getRandomWelcomeMessage,
        getRandomNewMessageTitle,
        requestedVisualTrigger,
    };

    function getAccordionItem(index) {
        switch (index) {
            case 0:
                return <FileUploadSettings index={index} {...props} {...fileUploadProps} />;
            case 1:
                return <AutoEngageSettings index={index} {...props} {...autoEngageProps} />;
            case 2:
                return <AutoReplySettings index={index} {...props} {...autoReplyProps} />;
            case 3:
                return <ContactModuleSettings index={index} {...props} {...contactModuleProps} />;
            default:
                return null;
        }
    }
    // style={{ backgroundColor: '#f3f3f3', borderRadius: '20px', boxShadow: '0 3px 3px #0003' }}
    return (
        <div>
            <h2>Workspace Settings</h2>
            <p>Configure your workspace settings to customize your chat user experience.</p>
            <div>
                <Accordion className="workspace-settings-accordion">
                    <Accordion.Item>
                        <Accordion.Header style={{ paddingLeft: '10px' }}>
                            <h4>Visualizer Settings</h4>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="noborder" style={{ padding: '5px' }}>
                                <VisualizerSettings {...props} />
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Accordion className="workspace-settings-accordion">
                    <Accordion.Item>
                        <Accordion.Header style={{ paddingLeft: '10px' }}>
                            <h4>Baseline Settings</h4>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="noborder" style={{ padding: '5px' }}>
                                <p>Configure your baseline settings to customize your chat user experience.</p>
                                <BaselineSettings {...props} {...baselineProps} />
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                {newSubscriptionItem && newSubscriptionItem.addons.map((addon, index) => {
                    if (!addon.enabled) {
                        return null;
                    }
                    return (
                        <Accordion key={index} className="workspace-settings-accordion">
                            <Accordion.Item>
                                <Accordion.Header style={{ paddingLeft: '10px' }}>
                                    <h4>{ADD_ONS[index].name}</h4>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="noborder" style={{ padding: '5px' }}>
                                        <p className="addon-description">
                                            {ADD_ONS[index].description}
                                        </p>
                                    </div>
                                    {getAccordionItem(index)}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    );
                })}
            </div>
        </div>
    );
}